/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum WaitingListStatus {
  ACTIVE = 'active',
  PROCESSED = 'processed',
  CONVERTED = 'converted',
}
